// Mobile swipe on product cards to reveal secondary image
(function () {
  if (window.matchMedia('(hover: hover)').matches) return; // skip desktop

  document.addEventListener('touchstart', handleTouchStart, { passive: true });
  document.addEventListener('touchend', handleTouchEnd, { passive: true });

  let touchStartX = 0;
  let touchStartY = 0;
  let activeCard = null;

  function handleTouchStart(e) {
    touchStartX = e.changedTouches[0].clientX;
    touchStartY = e.changedTouches[0].clientY;
    activeCard = e.target.closest('product-card');
  }

  function handleTouchEnd(e) {
    if (!activeCard) return;

    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;

    // Only trigger if horizontal swipe (not a scroll)
    if (Math.abs(dx) < 30 || Math.abs(dy) > Math.abs(dx)) return;

    const secondaryImg = activeCard.querySelector('[data-secondary-image]');
    if (!secondaryImg) return;

    const isShowingSecondary = activeCard.classList.contains('is-swiped');

    if (dx < 0 && !isShowingSecondary) {
      // Swipe left → show secondary
      activeCard.classList.add('is-swiped');
    } else if (dx > 0 && isShowingSecondary) {
      // Swipe right → back to primary
      activeCard.classList.remove('is-swiped');
    }

    activeCard = null;
  }
})();
